import { User } from "src/app/auth/model/user";
import { UserService } from "../service/user.service";
import { TranslateService } from "@ngx-translate/core";
import { UserRoles } from "src/app/shared/enums/user-roles";
import { PopupType } from "src/app/shared/enums/popup-types";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PasswordCustomValidators } from "src/app/shared/validators/password.validator";

@Component({
  selector: "app-user-form",
  templateUrl: "./user-form.component.html",
  standalone: false,
})
export class UserFormComponent implements OnInit {
  @Input() userId?: number;
  @Output() closeForm = new EventEmitter<null>();

  formGroup!: FormGroup;
  isLoading = false;

  options = [
    { value: UserRoles.SuperAdmin, label: "Super Admin" },
    { value: UserRoles.SuperAdminLight, label: "Super Admin Light" },
  ];

  constructor(
    private userService: UserService,
    public translate: TranslateService,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    if (this.userId) {
      const getSubscription = this.userService.getUser(this.userId).subscribe((response) => {
        getSubscription.unsubscribe();
        this.initForm(response);
      });
    }
    else {
      this.initForm();
    }
  }

  initForm(user: User = {} as User) {
    const { role } = user;

    this.formGroup = this.fb.group(
      {
        name: ["", this.userId ? [] : Validators.required],
        surname: ["", this.userId ? [] : Validators.required],
        email: ["", this.userId ? [] : [Validators.required, Validators.email]],
        password: ["", this.userId ? [] : [Validators.required, PasswordCustomValidators.passwordValidator]],
        role: [role, Validators.required],
      },
      { validators: PasswordCustomValidators.checkPasswords() },
    );
  }

  submitForm() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    if (this.userId) {
      const { role } = this.formGroup.getRawValue();
      this.isLoading = true;
      const updateSubscription = this.userService.updateUserRole(this.userId, role).subscribe({
        next: () => {
          updateSubscription.unsubscribe();
          this.isLoading = false;
          showMessage(PopupType.Success, this.translate.instant("users_page.role_successfully_updaed"));
          this.closeForm.emit(null);
        },
        error: (error) => {
          updateSubscription.unsubscribe();
          this.isLoading = false;
          showMessage(PopupType.Danger, error.message || error.toString());
        },
      });
    }
    else {
      this.isLoading = true;
      const createSubscription = this.userService.createUser(this.formGroup.getRawValue()).subscribe({
        next: () => {
          createSubscription.unsubscribe();
          this.isLoading = false;
          showMessage(PopupType.Success, this.translate.instant("user_successfully_created"));
          this.closeForm.emit(null);
        },
        error: (error) => {
          createSubscription.unsubscribe();
          this.isLoading = false;
          showMessage(PopupType.Danger, error.error || error.error.errors[0]?.description || error.toString());
        },
      });
    }
  }

  close() {
    this.closeForm.emit();
  }
}
